/**
 * Windermere Theme Configuration
 *
 * Nord Anglia / Windermere Preparatory School theme with navy color palette.
 * Uses the veneer system to overlay custom components (WindermereHeader,
 * WindermereLanding) on top of the base implementation.
 *
 * Veneer components are loaded from: src/themes/veneer/windermere/
 */

export const windermereTheme = {
  name: 'windermere',
  brandName: 'Windermere Preparatory School',
  logoPath: 'nord-anglia-school_windermere_logo_horizontal_white.png',

  // Enable veneer system for component overrides
  veneer: {
    enabled: true,
    // Components that use custom veneer versions
    components: ['LandingPage', 'AppHeader'],
  },

  colors: {
    headerColor: '#02233c',       // Windermere navy (primary)
    headerHover: '#011a2c',       // Darker navy for hover
    frameColor: '#1a3a5c',        // Windermere navy light
    buttonColor: '#9bd3dd',       // Light cyan/teal (accent/secondary use)
    buttonHover: '#7cc4d0',       // Darker teal for hover
    // Primary action buttons - dark navy for white text contrast
    primaryActionBg: '#02233c',   // Dark navy - high contrast with white text
    primaryActionBgHover: '#011a2c', // Darker navy for hover
    highlightButtonColor: '#992222',
    highlightButtonHover: '#7a1b1b',
    headerButtonColor: '#9bd3dd',
    textColor: '#02233c',
    lightTextColor: '#FFFFFF',
    buttonTextColor: '#02233c',
    headerTextColor: '#FFFFFF',
    headerButtonTextColor: '#02233c',
    alertColor: '#E32323',
    alertHover: '#c21e1e',
    successColor: '#699864',
    successHover: '#527a4d',
    inactiveColor: '#C3C3C3'
  },

  components: {
    header: 'WindermereHeader',
    hero: 'WindermereHero',
    landing: 'WindermereLanding',
    footer: 'GenericFooter'
  },

  features: {
    megaMenu: true,
    searchBar: true,
    scrollEffects: true,
    heroSection: true,
    quickActions: true,
    shopByGrade: true,
    shopByCollection: true,
    contactInMenu: true,
    instagramLink: true,
    promoBanner: true,
  },

  contact: {
    email: 'campus.store@windermereprep.com',
    phone: '(407) 905-7737',
    address: '6189 Winter Garden-Vineland Road, Windermere, FL 34786',
    instagram: 'https://instagram.com/windermereprep',
    website: 'https://www.windermereprep.com',
  },

  branding: {
    tagline: 'Part of the Nord Anglia Education family',
    heroTitle: 'WINDERMERE E-COMMERCE STORE',
    heroSubtitle: 'WELCOME TO',
    heroDescription: 'Windermere Preparatory School is the leading international prep school in Orlando and part of the worldwide Nord Anglia family of premium international schools.',
    heroImage: '/images/campus-store.png'
  }
}
